<template>
  <article>
    <Feature :title="'使用者權限維護'" :iconClass="'fa-user-circle-o'">
   
    </Feature>
  </article>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapActions } from 'vuex';

export default {
  name: "AccountMaintain",
  components: {
  },
  data() {
    return {

    }
  },
  created() {
    
  },
  methods: {
    ...mapGetters([
    ]),
    ...mapActions([
      'toggleLoading'
    ]),
  },
  mounted() {
    /* this.$http
      .get(`/test`)
      .then(response => {})
      .catch(() => {}) */
  },
}
</script>

<style scoped>
.father{
    box-sizing: border-box;
    width: 100%;
    height: 500px;
    overflow: hidden;
}
.leftChild{
    float: left;
    height: 100%;
    width: 50%;
    border: solid #5F9EA0;
    resize: horizontal;
    box-sizing: border-box;

}
.rightChild{
    float: left;
    height: 100%;
    width: calc(50% - 5px);
    border: solid	#5F9EA0;
    box-sizing: border-box;
}
#line{
    width: 2px;
    height: 100%;
    background-color: white;
    float: left;
    cursor: e-resize;
}
.cell-button-containe{
    box-sizing: border-box;
    width: 100%;
    overflow: hidden;
}
</style>
